module.exports = __webpack_public_path__ + "img/ambulance.b97052ce.jpeg";